import Typography from "@mui/material/Typography";

export function Title({
  children,
  variant = "h2",
  color = "textPrimary",
}: Readonly<{
  children: React.ReactNode;
  variant?: "h1" | "h2" | "h3" | "h4" | "h5";
  color?: "textPrimary" | "inherit" | "initial" | "primary" | "secondary" | "textSecondary" | "error";
}>) {
  return <Typography {...{ color, variant }}>{children}</Typography>;
}
